import { Alert, Button, Stack } from '@efast_public/fjd-component-library';
import {
  NachrichtType,
  NachrichtModel
} from '../../../../../api/models/Nachrichten/NachrichtModel';

interface NachrichtBodyProps {
  readonly nachricht: NachrichtModel;
  readonly onLinkClicked: () => void;
}

export function NachrichtBody({
  nachricht,
  onLinkClicked
}: NachrichtBodyProps) {
  const isPostalischBeschieden = (nachrichtType: NachrichtType): boolean => {
    return nachrichtType === NachrichtType.BESCHEID_POSTALISCH;
  };
  if (!nachricht.isSubmission) {
    return (
      <Stack direction="column">
        <div style={{ fontWeight: 600, fontSize: '12px' }}>Nachrichtentext</div>
        {!nachricht.isHtml ? (
          <div
            dangerouslySetInnerHTML={{
              __html: nachricht.nachrichtBody
            }}
          />
        ) : (
          <div>{nachricht.nachrichtBody}</div>
        )}
      </Stack>
    );
  } else {
    return isPostalischBeschieden(nachricht.nachrichtType) ? (
      <Alert
        data-testid="postalischAlert"
        variant="info"
        message="Der Bescheid wurde postalisch versandt."
      />
    ) : (
      <Alert
        data-testid="linkToDetails"
        variant="info"
        message="Genauere Angaben zu diesem Antrag finden Sie auf der Antragsdetailansicht."
      >
        <Button variant="secondary-outline" size="sm" onClick={onLinkClicked}>
          Antragsdetails öffnen
        </Button>
      </Alert>
    );
  }
}

export default NachrichtBody;
